import React from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { BillsAddButton } from "@pages/BillsPage/components/BillsAddButton/BillsAddButton";
import { PromotedAdditionalServices } from "@pages/BillsPage/components/PromotedAdditionalServices/PromotedAdditionalServices";
import { useJointBillServicePeriod } from "@pages/BillsPage/useJointBillServicePeriod";
import { JointBillList } from "@features/JointBillList/JointBillList";
import { BillsPageSkeleton } from "@features/skeletons/Bills/BillsPageSkeleton/BillsPageSkeleton";
import { TopBar } from "@components/TopBar/TopBar";
import { useFeatureConfig } from "@hooks/useFeatureFlags";
import { usePowerOfAttorneyAddBillModalSearchParamWatcher } from "@hooks/usePowerOfAttorneyAddBillModalSearchParamWatcher";
import { useOverviewQuery } from "@services/overview/queries";
import { BillsPageActionBar } from "./components/BillsPageActionBar/BillsPageActionBar";
import { ElectricityLeads } from "./components/ElectricityLeads/ElectricityLeads";

export const BillsPage: React.FC = () => {
  const { t } = useTranslation();
  const { isChubbInsuranceEnabled } = useFeatureConfig();

  const { isLoading: isPeriodIdLoading } = useJointBillServicePeriod();
  const { isLoading: isOverviewLoading } = useOverviewQuery();
  const isLoading = isOverviewLoading || isPeriodIdLoading;
  usePowerOfAttorneyAddBillModalSearchParamWatcher();

  if (isLoading) {
    return <BillsPageSkeleton />;
  }

  return (
    <div>
      <TopBar
        title={t("pages.bills.title")}
        actionBar={<BillsPageActionBar />}
      />
      <div
        className={twMerge(
          "px-4 pb-5 sm:hidden md:pb-4",
          isChubbInsuranceEnabled && "sm:flex md:hidden",
        )}
      >
        <BillsAddButton className="w-full" />
      </div>
      <div className="flex flex-col gap-6">
        <JointBillList />
        <ElectricityLeads />
        <div className="px-4 md:px-0">
          <PromotedAdditionalServices />
        </div>
      </div>
    </div>
  );
};
